function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M16.667 1.667l-15 9.166 5.966.995.7 5.255 2.311-3.85 6.023 4.684V1.667zm-7.93 8.655L6.35 9.924 15 4.638v9.87l-3.684-2.864L12.5 7.5l-3.763 2.822z"
});

var SvgPaperPlane = function SvgPaperPlane(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 20 20",
    fill: "none"
  }), _ref);
};

export default SvgPaperPlane;